import {
  DevicesAPI,
  UnlockProvisioningRequest,
  UnlockProvisioningResponse,
} from '@weave/schema-gen-ts/dist/schemas/phone/devices/v2/devices.pb';
import { useMutation, UseMutationOptions } from 'react-query';

import { authorizedFetch } from 'helpers/utils';
import { devicesQueryKeys } from './keys';

const useUnlockProvisioningMutation = (
  options?: UseMutationOptions<
    UnlockProvisioningResponse,
    Error,
    UnlockProvisioningRequest
  >
) => {
  return useMutation({
    mutationKey: devicesQueryKeys.unlockProvisioning(),
    mutationFn: (request: UnlockProvisioningRequest) => {
      if (!request.deviceIds) {
        return Promise.resolve({});
      }
      return DevicesAPI.UnlockProvisioning(authorizedFetch(), request);
    },
    ...options,
  });
};

export const DevicesMutations = {
  useUnlockProvisioningMutation,
};
